module.exports = __webpack_public_path__ + "img/btn-switch.b673e61d.png";